import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Laverage(props) {
  return (
    <div className="laverage_section hire_and_process p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our Streamlined Android Developer Hiring Process</h2>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Share Your Project Needs</h6>
                <p>Describe your requirements and project scope.</p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Review Qualified Candidates</h6>
                <p>Evaluate a list of pre-vetted developers.</p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Conduct Interviews</h6>
                <p>Assess developers through interviews and tests.</p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Start a Free Trial</h6>
                <p>Begin with a no-risk trial period.</p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Onboard Your Developer</h6>
                <p>
                  Hire and integrate the best-fit Android developer into your
                  team.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn web_case_btn"
              aria-label="Discuss Project Needs"
            >
              Hire Android Developers
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
